module.exports = __webpack_public_path__ + "assets/img/RewardBodyBtn2.ea80fd30.png";